module.exports = __webpack_public_path__ + "files/berthelot.a4c55c97e3f69cceb05f21c88fc91705.pdf";